import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=4a776a0a&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&lang=js"
import style0 from "./MentionsLegales.vue?vue&type=style&index=0&id=4a776a0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a776a0a",
  null
  
)

export default component.exports